<template>
<ValidationObserver ref="observer">
  <form ref="add_business_unit_form" @submit.prevent="addBusinessUnit">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="buname" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Business Unit Name</label>
                  <md-input v-model="business_unit_name" required/>
                  <validation-error :errors="apiValidationErrors.business_unit_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-textarea v-model="business_unit_remark" md-counter="255" maxlength="255" md-autogrow></md-textarea>
                  <validation-error
                    :errors="apiValidationErrors.business_unit_remark"
                  />
                  <md-avatar >
                    <md-icon style="color:blue;">report</md-icon>
                    <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                  </md-avatar>
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
        
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend('buname', {
  ...required,
  message: 'Name Field is required'
});
  
  export default {
     name: "add-business-unit",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    data: () => ({
      business_unit_name: null,
      business_unit_remark: null
    }),

    // created() {
    //   this.getLastNo();
    // },

  
    methods: {


      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Business Unit' })
    },


     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addBusinessUnit()
          }
        });
    },


    // fungsi add data
      async addBusinessUnit() {
       

        const data = {
          type: "fms_business_units",
          // client_no: this.client_no,
          business_unit_name: this.business_unit_name,
          business_unit_remark: this.business_unit_remark
        }


        try {
        await this.$store.dispatch("fms_business_unit/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // await this.$router.replace({name: 'List Business Unit'});
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
